import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { useEffect } from 'react';
import { HomeWrapper } from './Home.styles';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import { ThankYouContainer } from './ThankYouPage.styles';

function ThankYouPage() {
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
  }, []);

  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Greenia SRL | Collabora Con Noi</title>
        <meta name="description" content="Scopri tutto quello che devi sapere sulle assicurazioni nel nostro blog!" />
      </Helmet>
      <HomeWrapper>
        <Navbar />
        <ThankYouContainer className="d-flex justify-content-center flex-column align-items-center">
          <div className="custom-card shadow">
            <motion.h1
              initial={{ opacity: 0, y: -20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.3 }}
              className="text-center"
            >
              Grazie
            </motion.h1>
            <motion.p
              initial={{ opacity: 0, y: -20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.5 }}
              className="mb-5 h6 text-center"
            >
              Abbiamo ricevuto le tue informazioni. Sarai contattato a breve dal nostro team.
            </motion.p>
            <motion.div
              initial={{ opacity: 0, y: -20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.7 }}
            >
              <Link to="/" className="btn btn-success py-2 px-5">Torna Alla Home</Link>
            </motion.div>
          </div>
        </ThankYouContainer>
        <Footer />
      </HomeWrapper>
    </>
  );
}

export default ThankYouPage;
